import { combineReducers } from 'redux'

import { reducer as activeTab } from './State/activeTab'

export default combineReducers({
  activeTab,
})
